import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IntubationService } from '../../intubation/services/intubation.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import * as actions from '../store/options.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setSecuredViaOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const intubationService = new IntubationService(serviceId)
  try {
    const response: IOptionsResponse = yield call([intubationService, intubationService.getSecuredViaOptions])
    const { entity } = response
    yield put(actions.setSecuredViaOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setSecuredViaOptions() error: ${e}`))
  }
}
export function* setSecuredViaOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setSecuredViaOptions)
}
